export default __webpack_public_path__ + "static/media/trib01.aa4324a7.png";